import { createFileRoute, redirect } from "@tanstack/react-router";
import { Role } from "@/core/components/auth/auth.types";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { propertiesQueryOptions } from "@/core/components/sites/propertyQueryOptions";

export const Route = createFileRoute("/_layout/dashboard/connections/")({
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({ to: "/" });
		}
		if (auth.user?.role !== Role["Internal"]) {
			throw redirect({ to: "/dashboard" });
		}
	},
	loader: ({ context: { queryClient, auth } }) => {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		queryClient.ensureQueryData(propertiesQueryOptions(auth.token as string));
	},
	errorComponent: ErrorComponent,
	pendingComponent: LoadingList,
});
